import React from 'react';

import './style.scss';
const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-left">
        <div className="footer-item">
          Tecell Elektronik GmbH, UID: ATU68758622
        </div>
        <div className="footer-item">Pfarrhofgasse 14/9, A-1030 Wien</div>
        <div className="footer-item">Am Alten Sudhaus 5, D-90409 Nürnberg</div>
      </div>
      <div className="footer-right">
        <div className="footer-item">Web: www.suprabytes.com</div>
        <div className="footer-item">Email: office@suprabytes.com</div>
        <div className="footer-item">Tel: +43 699 110 87707</div>
      </div>
    </div>
  );
};

export default Footer;
